import React from 'react';
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function StatDirection({ value1, value2 }) {

    if (value1===value2) return
    return <span>
        {value1 > value2 ?
            <span style={{ color: "green" }}> {Math.abs(value1 - value2)} <FontAwesomeIcon icon={faArrowUp} /> </span> :
            <span style={{ color: "red" }}>  {Math.abs(value1 - value2)} <FontAwesomeIcon icon={faArrowDown} /></span>}
    </span>
}